/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Types of visual display elements in the video player UI.
 * Used to control which visual elements are shown during playback.
 */
export enum VisualDisplayTypes {
  /**
   * Information overlay (e.g., program info, error messages).
   */
  OVERLAY = 0,

  /**
   * On-Screen Display (e.g., transport controls, channel banner).
   */
  OSD = 1,

  /**
   * Loading/buffering spinner.
   */
  SPINNER = 2
}
